import {round} from "../utils/math"
import keys from 'lodash/keys'
import inDOM from 'dom-helpers/util/inDOM';

export const LINE_HEIGHT = 1.8;
export const BASE_FONT_SIZE_PIXELS = 16;
export const BASE_PIXELS = 16;

const ICONIC_REM_CONVERSION = 16/BASE_FONT_SIZE_PIXELS;

const categoryColors = {
    style: '#FF8E4D',
    sport: '#42ABC8',
    advice: '#FF8E4D',
    lookbook: '#FF8E4D',
    lookbooks: '#FF8E4D',
    trending: '#FF8E4D',
    lifestyle: '#8D405E',
    news: '#FF8E4D',
    default: '#FF8E4D',
    topPicks: '#FF8E4D',
    'the iconic tv': '#349C5F'
}

const colors = {
    black: '#464646',
    white: "#FFF",
    primary: "#42abc8",
    divider: "#cdcdcd",
    subTitle: "#B0B0B0",
    assent: "#9b9b9b",
    footer: "#000",
    info: "#f5f5f5",
    header: '#000',
    faintGrey: '#C4C4C4',
    lightGrey: '#CDCDCD',
    lightBlue: '#42ABC8',
    border: '#464646',
    borderBlue: '#5DB4CF',
    activeBlue: '#55B3CD',
    universalNav: '#232323',
    ...categoryColors
}

const breakpoints = {
    mobile: 450,
    tablet: 768,
    laptop: 960,
    desktop: 1440,
    huge: 1800,
}

export function currentBreakpoint() {
    const viewportWidth = inDOM ? document.documentElement.clientWidth : 0;
    const bpKeys = keys(breakpoints);
    for (let i = bpKeys.length - 1; i > 0; i -= 1) {
        const bp = bpKeys[i];
        if (breakpoints[bp] <= viewportWidth) {
            return bp;
        }
    }
    return bpKeys[0];
}

function getArticleColor(category, tags) {
    // if(tags) {
    //     var color = first(map(pick(categoryColors, tags), x => x));
    //     if(color) return color;
    // }
    return categoryColors[category.toLowerCase()] || categoryColors.default;
}

function getLandingPageColor(landingPageUid) {
    return categoryColors[landingPageUid.toLowerCase()] || categoryColors.default;
}

function breakpoint(breakpointName, type="min") {
    var breakpointPixels = breakpoints[breakpointName];
    if( ! breakpointPixels ) return `@media (${type}-width: ${Math.round(breakpointName)}rem)`
    if(type === "max") breakpointPixels -= 1;
    return `@media (${type}-width: ${round(breakpointPixels/BASE_PIXELS)}rem)`
}

function getRemValue(sizeInPixes) {
    return `${round(sizeInPixes/BASE_FONT_SIZE_PIXELS)}rem`
}

function getPixelValue(sizeInRems) {
    return sizeInRems*BASE_FONT_SIZE_PIXELS;
}


export default {
    ds: {
      spacing: (size) => size * 8
    },
    convertFromIconicRemValue: (sizeIn16pxRemValue) => {
        return `${round(sizeIn16pxRemValue*ICONIC_REM_CONVERSION)}rem`
    },
    getRemValue,
    getArticleColor,
    getLandingPageColor,
    base: {
        fontSize: BASE_FONT_SIZE_PIXELS,
        lineHeight: LINE_HEIGHT,
    },
    card: {
        styles: {
            boxShadow: '0 0 8px 0.5px rgba(0, 0, 0, 0.05)',
            borderRadius: [0, 0, 5, 5],
            transition: 'box-shadow 0.15s ease-out',
        },
        image: {
            borderRadius: 5,
        },
        hover: {
            boxShadow: '0 0 20px 1px rgba(0, 0, 0, 0.3)',
        },
        gutter: 20
    },
    zIndex: {
        carousel: 800,
        card: 801,
        header: 900,
        overlay: 901,
        dropdown: 903,
        //dialog: 905,
        menu: 910,
        searchDialog: 911,
        dialog: 920,
    },
    breakpoints: breakpoints,
    breakpoint: breakpoint,
    content: {
        width: 848, //780
        widthSmall: 660,
        widthMedium: 960,
        widthLarge: 1280,
        widthXLarge: 1396,
    },
    header: {
        height: (prop) => ({
            [prop]: 56,
            [breakpoint("tablet")]: {
                [prop]: 70,
            }
        }),
        backgroundColor: '#000',
        textColor: colors.white,
    },
    colors: colors,
    link: {
        color: colors.primary,
        hover: {
            color: colors.primary,
        }
    },
    spacing: {
        tiny: `${round(LINE_HEIGHT/2.2)}rem`,
        small: `${round(LINE_HEIGHT/2)}rem`,
        normal: `${LINE_HEIGHT}rem`,
        large: `${round(LINE_HEIGHT*2)}rem`,
        huge: `${round(LINE_HEIGHT*2.5)}rem`,
        smallMarginBottom: {
            marginBottom: `${round(LINE_HEIGHT/3)}rem`,
            [breakpoint("tablet")]: {
                marginBottom: `${round(LINE_HEIGHT/2)}rem`,
            }
        },
        normalMarginBottom: {
            marginBottom: `${round(LINE_HEIGHT/2)}rem`,
            [breakpoint("tablet")]: {
                marginBottom: `${LINE_HEIGHT}rem`,
            }
        },
        largeMarginBottom: {
            marginBottom: `${LINE_HEIGHT}rem`,
            [breakpoint("tablet")]: {
                //marginBottom: `${round(LINE_HEIGHT*2)}rem`,
                marginBottom: '3rem',
            }
        }
    },
    spacingPx: {
        tiny: getPixelValue(LINE_HEIGHT/3),
        small: getPixelValue(LINE_HEIGHT/2),
        normal: getPixelValue(LINE_HEIGHT),
        large: getPixelValue(LINE_HEIGHT*2),
        huge: getPixelValue(LINE_HEIGHT*2.5),
    },
    animation: {
        easing: {
            standardCurve: "cubic-bezier(0.4, 0.0, 0.2, 1)",
            decelerationCurve: "cubic-bezier(0.0, 0.0, 0.2, 1)",
            accelerationCurve: "cubic-bezier(0.4, 0.0, 1, 1)",
            sharpCurve: "cubic-bezier(0.4, 0.0, 0.6, 1)"
        },
        standardDuration: 0.3,
        imageHover: {
            transition: "filter 400ms, opacity 400ms",
            "&:hover": {
                filter: "brightness(105%)"
            }
        }
    },
    // Look at this site for some information on single direction margin for better vertical rythem:
    // https://csswizardry.com/2012/06/single-direction-margin-declarations/
    font: {
        family: "proxima-nova, sans-serif",
        familyBoldStyle: {
            fontFamily: "proxima-nova, sans-serif",
            fontWeight: 700,
        },
        titleFontFamily: "linotype-didot, serif",
        menu: {
            normal: {
                fontFamily: "proxima-nova, sans-serif",
                fontSize: getRemValue( 13 ),
                lineHeight: `1.2em`,
            },
            mobile: {
                fontSize: getRemValue( 16 ),
                fontWeight: 700,
                letterSpacing: '0.8px',
                lineHeight: '40px'
            }
        },
        p: {
            fontSize: BASE_FONT_SIZE_PIXELS,
            lineHeight: '26px',
            fontWeight: 200,
            letterSpacing: 0.2,
            marginBottom: '1rem',
            [breakpoint("tablet")]: {
                fontSize: getRemValue( 18 ),
                lineHeight: '32px',
                letterSpacing: 0.3,
                marginBottom: '2rem'
            },
        },
        li: {
            fontSize: BASE_FONT_SIZE_PIXELS,
            lineHeight: '26px',
            fontWeight: 200,
            letterSpacing: 0.2,
            [breakpoint("tablet")]: {
                fontSize: getRemValue( 18 ),
                lineHeight: '32px',
                letterSpacing: 0.3            },
        },
        title: {
            h1: {
                color: colors.black,
                textTransform: "uppercase",
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                fontSize: getRemValue( 26 ),
                lineHeight: getRemValue( 32 ),
                [breakpoint("tablet")]: {
                    fontSize: getRemValue( 42 ),
                    lineHeight: getRemValue( 50 ),
                }
            },
            h2: {
                color: colors.black,
                textTransform: "uppercase",
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                fontSize: getRemValue( 26 ),
                lineHeight: getRemValue( 32 ),
                [breakpoint("laptop")]: {
                    fontSize: getRemValue( 32 ),
                    lineHeight: getRemValue( 40 ),
                },
            },
            h3: {
                color: colors.black,
                textTransform: "uppercase",
                fontStyle: "normal",
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                fontSize: getRemValue( 22 ),
                lineHeight: `${LINE_HEIGHT}rem`,
                [breakpoint("tablet")]: {
                    fontSize: getRemValue( 23 ),
                    lineHeight: `${round(LINE_HEIGHT*2)}rem`,
                },
            },
            h4: {
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                fontSize: getRemValue( 18 ),
                lineHeight: `${LINE_HEIGHT}rem`,
            },
            h5: {
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                fontSize: getRemValue( 16 ),
                lineHeight: `${LINE_HEIGHT}rem`,
            },
            h6: {
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                fontSize: getRemValue( 14 ),
                lineHeight: `${LINE_HEIGHT}rem`,
                letterSpacing: '0.8px',
            },
            listing: {
                color: colors.black,
                textTransform: "uppercase",
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                marginBottom: `${round(LINE_HEIGHT/2)}rem`,
                fontSize: getRemValue( 22 ),
                lineHeight: `${LINE_HEIGHT}rem`,
                [breakpoint("tablet")]: {
                    fontSize: getRemValue( 26 ),
                    lineHeight: getRemValue( 38 ),
                },
            },
        },
        subtitle: {
            fontStyle: "italic",
            fontWeight: "normal",
            fontFamily: "linotype-didot, serif",
            color: colors.subTitle,
            fontSize: getRemValue( 18 ),
            lineHeight: '1.6rem',
            [breakpoint("tablet")]: {
                fontSize: getRemValue( 22 ),
                lineHeight: '2rem'
            }
        },
        fieldLabel: {
            fontWeight: "normal",
            fontSize: getRemValue(16),
            lineHeight: `${LINE_HEIGHT}rem`,
        },
        link: {
            fontFamily: "proxima-nova, sans-serif",
            fontSize: getRemValue( 12 ),
            lineHeight: `${LINE_HEIGHT}rem`,
            fontWeight: "bold",
            textTransform: "uppercase",
            '&:hover': {
                textDecoration: 'none'
            }
        },
        linkButton: {
            color: colors.black,
            fontFamily: "proxima-nova, sans-serif",
            fontSize: getRemValue( 10 ),
            lineHeight: `${LINE_HEIGHT}rem`,
            fontWeight: 700,
            textTransform: "uppercase",
            cursor: 'pointer',
            [breakpoint("tablet")]: {
                fontSize: getRemValue( 10 ),
            },
        },
        info: {
            fontSize: getRemValue( 12 ),
            fontWeight: 200,
            lineHeight: '1.6rem',
            [breakpoint("tablet")]: {
                fontSize: getRemValue( 14 ),
            },
        },
        caption: {
            fontFamily: "proxima-nova, sans-serif",
            fontSize: getRemValue( 9 ),
            fontWeight: "normal",
            //lineHeight: `${LINE_HEIGHT}rem`,
            lineHeight: "1rem"
        },
        label: {
            textTransform: "uppercase",
            fontWeight: 200,
            fontFamily: "proxima-nova-extra-condensed, sans-serif",
        },
        pullQuote: {
            "&, & p": {
                fontWeight: "normal",
                fontFamily: "linotype-didot, serif",
                fontSize: getRemValue(16),
                lineHeight: `${LINE_HEIGHT}rem`,
                textTransform: "uppercase",
                [breakpoint("mobile")]: {
                    fontSize: getRemValue(18),
                    lineHeight: `${LINE_HEIGHT}rem`,
                },
                [breakpoint("tablet")]: {
                    fontSize: getRemValue(22),
                    lineHeight: `${LINE_HEIGHT}rem`,
                },
            }
        },
        pullQuoteSmall: {
            "&, & p": {
                [breakpoint("mobile", 'max')]: {
                    fontSize: getRemValue(14),
                    lineHeight: `${LINE_HEIGHT / 2}rem`
                }
            }
        },
        pullQuoteAttribution: {
            textTransform: "uppercase",
            fontFamily: "proxima-nova, sans-serif",
            fontWeight: "normal",
            fontSize: getRemValue( 9 ),
        }
    },
}


// WEBPACK FOOTER //
// ./src/styles/theme.js